import { createBrowserRouter, RouterProvider } from "react-router-dom";

import { AuthProvider } from "../features/auth/AuthContext";
import { AuthenticatedIndexRedirect, RequireAuth, RequireRole } from "../features/auth/RouteGuards";
import { AppShell } from "../features/shell/AppShell";
import { AuditEventsPage } from "../pages/AuditEventsPage";
import { LoginPage } from "../pages/LoginPage";
import { PlaceholderPage } from "../pages/PlaceholderPage";
import { PlatformStatisticsPage } from "../pages/PlatformStatisticsPage";
import { ProjectDetailPage } from "../pages/ProjectDetailPage";
import { ProjectManagementPage } from "../pages/ProjectManagementPage";
import { ProjectImportPage } from "../pages/ProjectImportPage";
import { RegistrantManagementPage } from "../pages/RegistrantManagementPage";
import { ReviewTaskDetailPage } from "../pages/ReviewTaskDetailPage";
import { ReviewTasksPage } from "../pages/ReviewTasksPage";
import { UserManagementPage } from "../pages/UserManagementPage";

const router = createBrowserRouter([
  { path: "/login", element: <LoginPage /> },
  {
    element: <RequireAuth />,
    children: [
      {
        path: "/",
        element: <AppShell />,
        children: [
          { index: true, element: <AuthenticatedIndexRedirect /> },
          {
            element: <RequireRole roles={["NORMAL_USER"]} />,
            children: [
              { path: "projects", element: <ProjectManagementPage /> },
              { path: "projects/:projectId", element: <ProjectDetailPage /> },
              { path: "project-imports", element: <ProjectImportPage /> },
              { path: "registrants", element: <RegistrantManagementPage /> },
            ],
          },
          {
            element: <RequireRole roles={["REVIEWER"]} />,
            children: [
              { path: "review-tasks", element: <ReviewTasksPage /> },
              { path: "review-tasks/:assignmentId", element: <ReviewTaskDetailPage /> },
            ],
          },
          {
            element: <RequireRole roles={["ADMIN"]} />,
            children: [
              { path: "admin/projects", element: <ProjectManagementPage /> },
              { path: "admin/projects/:projectId", element: <ProjectDetailPage /> },
              {
                path: "admin/platform-statistics",
                element: <PlatformStatisticsPage />,
              },
              {
                path: "admin/review-assignments",
                element: <ReviewTasksPage admin />,
              },
              { path: "admin/registrants", element: <RegistrantManagementPage /> },
              { path: "admin/users", element: <UserManagementPage /> },
              { path: "admin/audit-events", element: <AuditEventsPage /> },
            ],
          },
          { path: "*", element: <PlaceholderPage title="页面不存在" /> },
        ],
      },
    ],
  },
]);

export function App() {
  return (
    <AuthProvider>
      <RouterProvider router={router} />
    </AuthProvider>
  );
}
